import { useState, useEffect } from "react";
import date from "date-and-time";

import ModelActivity from "./models/ModelActivity";
import ItemCard from "./components/ItemCard";
import { SearchRecord } from "components/Tools/SearchRecord";
import CalendarFilter from "components/Tools/CalendarFilter";
import PureModal from "components/Modals/PureModal";
import ModalWizzardActivityInformation from "./components/ModalWizzardActivityInformation";
import proxy from "api/proxy";
import { getStorage } from "store/local";
import Button from "componentsv2/button/Button";
import funcs from "tools/functions";
import { DonwloadIcon } from "components/Icons";

const ActivityInformation = (props) => {
  const dayToday = new Date();
  const { config } = props;
  const ctxViewActi = ModelActivity.ctxView(config);
  const [activityData, setSearchData] = useState([]);
  const [originalActivityData, setOriginalActivityData] = useState([]);
  const [filterDay, setFilterDay] = useState(dayToday);
  const [onOpen, setOnOPen] = useState(false);
  const [idSchedule, setIdSchedule] = useState(null);
  const day = new Date();
  const dayFormatted = date.format(day, "YYYY-MM-DD");
  const dayFormattedEnd = date.format(day, "YYYY-MM-DD");
  const session = getStorage("ctxSession");
  const { groups } = session;
  const permissionBtnReport = groups.some(
    (item) => item.name === "Reporte de Informacion de Actividades",
  );

  function handleChangeDate(value) {
    const daySelected = new Date(value);
    daySelected.setDate(daySelected.getDate() + 1);
    const _daySelected = date.format(new Date(daySelected), "YYYY-MM-DD");
    setFilterDay(_daySelected);
  }

  async function getActivity() {
    const saleActivity = getStorage("saleActivity");
    const day = new Date(filterDay);
    const dayFormatted = date.format(day, "YYYY-MM-DD");
    const dom = [["date_activity", "=", dayFormatted]];
    let fields = [
      "kind",
      "kind.name",
      "kind.image",
      "kind.employee.party.name",
      "kind.product.list_price",
      "kind.product.sale_price_w_tax",
      "kind.product.image_url",
      "kind.product.images",
      "date_activity",
      "activities",
      "activities.quota",
      "activities.available",
      "activities.state",
      "id",
    ];

    if (saleActivity?.modules_active.includes("product_kit")) {
      const component_fields = [
        "kind.product.components.sale_price_w_tax",
        "kind.product.components.quantity",
      ];
      fields = fields.concat(component_fields);
    }
    const { data: res } = await proxy.search(
      "sale_activity.schedule",
      dom,
      fields,
    );
    if (res) {
      const res_ = res.map((activity) => ({
        id: activity.id,
        name: activity["kind."].name ?? "",
        date_activity: activity.date_activity,
        kind: activity["kind."].id,
        activities: activity["activities."],
        price: activity["kind."]?.["product."].sale_price_w_tax,
        image: null,
        img: activity["kind."]?.image,
      }));
      setSearchData(res_);
      setOriginalActivityData(res_);
    }
  }

  function resetSearchData() {
    setSearchData(originalActivityData);
  }

  function handleChangeActivity(id) {
    setIdSchedule(id);
    setOnOPen(true);
  }

  async function handleDownloadReport() {
    const day = new Date(filterDay);
    const dayFormatted = date.format(day, "YYYY-MM-DD");
    const storeStd = {
      start_date: dayFormatted,
      end_date: dayFormatted,
      kind: null,
      salesman: null,
      commercial: true,
      // company: session.company,
    };

    const { reportUrl, nameFile } = await proxy.report({
      report: "sale_activity.report_sale_activities.report",
      data: storeStd,
      records: [],
    });

    if (reportUrl && nameFile) {
      funcs.createReportLink(reportUrl, nameFile);
    }
    return true;
  }

  useEffect(() => {
    getActivity();
  }, [filterDay]);

  return (
    <div id="board" className="mx-4 my-3 w-full mt-10 px-8 ">
      <CalendarFilter action={handleChangeDate} />
      <hr className="mt-10 mb-10" />
      <SearchRecord
        data={activityData}
        setSearchData={setSearchData}
        resetSearchData={resetSearchData}
        title="¿Qué actividad buscas?"
      />
      <div className="grid grid-cols-4 gap-3 mt-10">
        {activityData.map((activity, key) => (
          <ItemCard
            activity={activity}
            keyId={key}
            key={key}
            handleChangeActivity={handleChangeActivity}
            dayFormatted={dayFormatted}
            dayFormattedEnd={dayFormattedEnd}
          />
        ))}
      </div>
      {permissionBtnReport && (
        <div>
          <Button
            color="amber"
            onClick={handleDownloadReport}
            content={"Reporte informe de actividades"}
            style="mx-auto mt-20 mb-5"
            size="w-fit"
            iconRight={<DonwloadIcon className="w-7 h-7" />}
          />
        </div>
      )}

      <PureModal open={onOpen} onClose={() => setOnOPen(onOpen ? false : true)}>
        <ModalWizzardActivityInformation
          key="button_wizard"
          model="sale_activity.activity"
          ctxView={ctxViewActi}
          onAccept={() => null}
          onClose={() => setOnOPen(onOpen ? false : true)}
          idSchedule={idSchedule}
          onOpen={onOpen}
        />
      </PureModal>
    </div>
  );
};

export default ActivityInformation;
